import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { RotateCcw } from "lucide-react";
import { useCart } from "../../pages/ShopCart";
import { COLORS, GhostButton } from "./ui";
import { useI18n } from "../../lib/i18n";

const API = process.env.REACT_APP_BACKEND_URL;

// Remet les articles d'une ancienne commande dans le panier, au prix du jour.
export const ReorderButton = ({ lines, testid }) => {
  const { add } = useCart();
  const { t } = useI18n();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  const run = async () => {
    setBusy(true); setMsg("");
    try {
      const res = await fetch(`${API}/api/shop/products`, { credentials: "include" });
      const products = res.ok ? await res.json() : [];
      const byId = Object.fromEntries((Array.isArray(products) ? products : products.items || []).map((p) => [p.id, p]));
      const wanted = (lines || []).filter((l) => l.product_id && !String(l.product_id).startsWith("__"));
      const missing = [];
      let added = 0;
      wanted.forEach((l) => {
        const p = byId[l.product_id];
        if (!p || p.in_stock === false || p.available === false) { missing.push(l.product_name || l.description || l.name || "Article"); return; }
        add(p, Math.max(1, Math.round(Number(l.quantity) || 1)));
        added += 1;
      });
      if (!added) { setMsg(t("reorder.none")); return; }
      navigate("/boutique/panier", { state: { reorderMissing: missing } });
    } catch (e) {
      setMsg(e.message || "Erreur");
    } finally { setBusy(false); }
  };

  return (
    <span className="inline-flex flex-col items-end">
      <GhostButton onClick={run} loading={busy} icon={RotateCcw} testid={testid}>{t("reorder.btn")}</GhostButton>
      {msg && <span className="text-[10px] mt-1" style={{ color: COLORS.chili }} data-testid={`${testid}-msg`}>{msg}</span>}
    </span>
  );
};

export default ReorderButton;
